// import React, { cloneElement } from "react";
// import { useTranslation } from "react-i18next";
// import { useLocation, useNavigate } from "react-router-dom";
// import { useDispatch, useSelector } from "react-redux";
// import NavItemHeader from "./NavItemHeader";
// import { openTab } from "../../features/tabs/tabSlice";

// const NavItem = ({ item }) => {
//   let { id, title, icon, component, childs } = item;
//   const { pathname } = useLocation();
//   const selectedTab = useSelector((state) => state.tab.selectedTab);
//   const navigate = useNavigate();
//   const dispatch = useDispatch();
//   const { t } = useTranslation();
//   title = t(title);

//   if (childs?.length) {
//     return <NavItemHeader item={{ ...item, title }} />;
//   }

//   const onItemClick = (e) => {
//     if (item.tab === false) {
//       return;
//     }

//     dispatch(openTab({ id, title, component }));
//     if (pathname !== "/") {
//       navigate("/");
//     }
//   };
//   const notClick = (e) => {
//     e.preventDefault();
//   };
//   return (
//     <>
//       {item?.component?.length > 0 ? (
//         <li
//           className="relative"
//           onClick={title !== "Users" || "TV" ? onItemClick : notClick}
//         >
//           <button
//             data-active={selectedTab === id}
//             className="block py-1 px-6 hover:text-indigo-500 dark:text-gray-300 data-[active=true]:dark:text-gray-100 dark:hover:text-gray-100"
//             href="#"
//           >
//             {icon && cloneElement(icon)}
//             <span>{title}</span>
//           </button>
//         </li>
//       ) : (
//         <li className="relative" onClick={item.onclick}>
//           <button
//             className="block py-1 px-6 hover:text-indigo-500 dark:text-gray-300 dark:hover:text-gray-100"
//             href="#"
//           >
//             {icon && cloneElement(icon)}
//             <span>{title}</span>
//           </button>
//         </li>
//       )}
//     </>
//   );
// };

// export default NavItem;

// src/components/menus/NavItem.jsx
import React, { cloneElement } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { openTab } from "../../features/tabs/tabSlice";
import NavItemHeader from "./NavItemHeader";

const NavItem = ({ item }) => {
  const { id, icon, component, childs } = item;
  const { pathname } = useLocation();
  const selectedTab = useSelector((state) => state.tab.selectedTab);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const title = t(item.title);

  // Alt menüsü olan başlıklar
  if (Array.isArray(childs) && childs.length > 0) {
    return <NavItemHeader item={{ ...item, title }} />;
  }

  const isNewLicence =
    item.id === 34 || component === "admin/newLicence/NewLicence";

  const handleClick = (e) => {
    e.preventDefault();

    // Menüde "tab=false" ise hiçbir şey yapma
    if (item.tab === false) return;

    // ✅ New Licence -> sadece modal aç
    if (isNewLicence) {
      window.dispatchEvent(
        new CustomEvent("AKEAD:modal-open", { detail: { modal: "new-licence" } })
      );
      return;
    }

    // ✅ Diğer menüler -> tab aç (Redux state'e React element koymuyoruz)
    if (component && typeof component === "string") {
      dispatch(
        openTab({
          id: String(id),
          title,
          component,
          componentProps: item.componentProps || {},
          // İkonu Redux'a değil, sadece menüde render ediyoruz (store'a element koymuyoruz)
          // Tab header'da gerekiyorsa anahtar bazlı render edin (tabIconKey)
          tabIconKey: item.tabIconKey || item.iconKey || null,
        })
      );
      if (pathname !== "/") navigate("/");
    }
  };

  return (
    <li className="relative">
      <button
        type="button"
        onClick={handleClick}
        data-active={selectedTab === id}
        className="py-1 px-6 hover:text-indigo-500 dark:text-gray-300 data-[active=true]:dark:text-gray-100 dark:hover:text-gray-100 w-full text-left flex items-center gap-2"
      >
        {/* İkonu MENÜDE göster (Redux'a koymuyoruz) */}
        {icon ? cloneElement(icon) : null}
        <span>{title}</span>
      </button>
    </li>
  );
};

export default NavItem;
